import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ScannerFacade } from './+state';
import { ScannerStateModule } from './+state/scanner.state.module';
import { ScannerCallbacksBuilder } from './builders';
import { CloseScannerGuard } from './guards/close-scanner.guard';
import { ShowScannerGuard } from './guards/show-scanner.guard';
import { ScannerSettingsProvider } from './providers';
import { ScannerAdapterServiceBase, ScannerAdapterServiceMock, ScannerAdapterService } from './services';

@NgModule({
  imports: [CommonModule, ScannerStateModule],
})
export class DomainScannerModule {
  public static forRoot(config: { useMockScanner: boolean }): ModuleWithProviders {
    return {
      ngModule: DomainScannerModule,
      providers: [
        {
          provide: ScannerAdapterServiceBase,
          useClass: config.useMockScanner ? ScannerAdapterServiceMock : ScannerAdapterService,
        },
        ScannerSettingsProvider,
        ScannerCallbacksBuilder,
        ShowScannerGuard,
        CloseScannerGuard,
        ScannerFacade,
      ],
    };
  }
}
